/* eslint-disable no-throw-literal */
const loginServiceUrl = () => {
  const url = process.env.LOGIN_SERVICE_URL;
  if (!url) {
    throw 'Unknown environment.';
  }
  return url;
};

export default loginServiceUrl;
